import { useMemo } from "react"
import PropTypes from "prop-types"
import { ListItemButton, ListItemAvatar, ListItemText, Avatar, Checkbox } from "@mui/material"
import { UNIVERSAL_SEARCH_RESULT } from "helpers/shapes"
import { useHover } from "hooks/hover"
import { getHighlightedText } from "../helpers"
import { SecondaryText } from "./secondary-text"
import { SecondaryIcon } from "./secondary-icon"
import { DashboardButton } from "modules/resources/components/resource/buttons"

export default function SearchResult({ item, disableResult, handleAction, multiSelect, resultSelected, value }) {
  const [isHovering, hoverBind] = useHover()
  const disabled = useMemo(() => disableResult(item) || (!item.mainAction && !item.secondaryAction && !item.dashboardAction), [item, disableResult])

  const shouldAdjustHoverText = useMemo(() =>
    isHovering && item.dashboardAction,
  [isHovering, item.dashboardAction])

  return <ListItemButton
    {...hoverBind}
    data-testid={item.description}
    className="unified-search-item"
    classes={{
      root: !item.mainAction && "no-main-action",
    }}
    tabIndex={-1}
    disabled={disabled}
    onClick={item.mainAction ? () => handleAction(item.mainAction, item.noDispatch, null, item) : null}
    selected={item.selected}
  >
    <ListItemAvatar>
      <Avatar className={`item-type-${item.iconType}`}>
        {item.icon}
      </Avatar>
    </ListItemAvatar>
    <ListItemText classes={{ primary: "search-result-description" }} primary={getHighlightedText(item.description, value)} secondary={<SecondaryText {...item} isHovering={shouldAdjustHoverText} value={value} />} />
    {item.secondaryAction && <SecondaryIcon item={item} handleAction={handleAction} />}
    {item.dashboardAction && <DashboardButton onClick={() => handleAction(item.dashboardAction, item.noDispatch, item.dashboardActionOnly, item)} />}
    {multiSelect && <Checkbox disabled={disabled} checked={resultSelected(item)} />}
  </ListItemButton>
}

SearchResult.propTypes = {
  item: PropTypes.shape(UNIVERSAL_SEARCH_RESULT).isRequired,
  disableResult: PropTypes.func.isRequired,
  handleAction: PropTypes.func.isRequired,
  multiSelect: PropTypes.bool.isRequired,
  resultSelected: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
}
